import back from "../assets/back-2.svg"

export default function ButtonBack({clickEvent}){
    
    return(
        <div className="modal-back-btn" onClick={clickEvent}><img src={back} /></div>
    )

}